module.exports = __webpack_public_path__ + "img/code-phone.84c13e7e.png";